<div class="card">
	<div class="card-header">
		<h1>Mapa de Calor (Compra)</h1>
	</div>
	<div class="card-body">
		<div class="row mb-3">
			<div class="col form-group">
				<label for="month" class="form-label">Mes</label>
				<select name="month" id="month" (change)="getHeatMap()" class="form-select" [(ngModel)]="month">
					<option [ngValue]="1">Enero</option>
					<option [ngValue]="2">Febrero</option>
					<option [ngValue]="3">Marzo</option>
					<option [ngValue]="4">Abril</option>
					<option [ngValue]="5">Mayo</option>
					<option [ngValue]="6">Junio</option>
					<option [ngValue]="7">Julio</option>
					<option [ngValue]="8">Agosto</option>
					<option [ngValue]="9">Septiembre</option>
					<option [ngValue]="10">Octubre</option>
					<option [ngValue]="11">Noviembre</option>
					<option [ngValue]="12">Diciembre</option>
				</select>
			</div>
			<div class="col form-group">
				<label for="year" class="form-label">Año</label>
				<select name="year" id="year" (change)="getHeatMap()" class="form-select" [(ngModel)]="year">
					<option *ngFor="let y of years" [ngValue]="y">{{y}}</option>
				</select>
			</div>
			<div class="col form-group">
				<label for="warehouse" class="form-label">Bodega</label>
				<select name="warehouse" id="warehouse" (change)="getHeatMap()" class="form-select" [(ngModel)]="warehouse">
					<option *ngFor="let warehouse of warehouses" [ngValue]="warehouse.id">{{warehouse.name}}</option>
				</select>
			</div>
			<div class="col form-group">
				<label for="type" class="form-label">Tipo</label>
				<select name="type" id="type" (change)="getHeatMap()" class="form-select" [(ngModel)]="type">
					<option [ngValue]="1">Mapa de Facturas</option>
					<option [ngValue]="2">Flujo de dinero</option>
				</select>
			</div>
		</div>
		<div id="apex-heat-map"></div>
		<button class="btn btn-primary" (click)="downloadRealValuesCSV()">Descargar CSV</button>
	</div>
</div>